import React, { useRef } from "react";
import NumberFormat from 'react-number-format';
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import moment from "moment";

function CoafDateRangePicker(props) {
    const { t } = useTranslation();
    const { startDate, endDate, onDatesChange, error } = props;
    const { readOnly } = props

    const startInputRef = useRef(null);
    const endInputRef = useRef(null);

    const getStartValue = () => {
        return startDate && moment(startDate).isValid() ? moment(startDate).format("DDMMYYYY") : "";
    };

    const getEndValue = () => {
        return endDate && moment(endDate).isValid() ? moment(endDate).format("DDMMYYYY") : "";
    };

    const handleStartChange = (values) => {
        const { value } = values;
        let newStartIso = null;
        if (value.length === 8) {
            const m = moment(value, "DDMMYYYY", true);
            if (m.isValid()) {
                newStartIso = m.startOf('day').toISOString();
                if (endInputRef.current) endInputRef.current.focus();
            }
        }
        if (newStartIso !== startDate) {
            const nextEnd = value.length === 0 ? null : endDate;
            onDatesChange({ startDate: newStartIso, endDate: nextEnd });
        }
    };

    const handleEndChange = (values) => {
        const { value } = values;
        let newEndIso = null;
        if (value.length === 8) {
            const m = moment(value, "DDMMYYYY", true);
            if (m.isValid()) newEndIso = m.endOf('day').toISOString();
        }
        if (newEndIso !== endDate) {
            onDatesChange({ startDate, endDate: newEndIso });
        }
    };

    const handleStartKeyDown = (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (endInputRef.current) endInputRef.current.focus();
        }
    };

    const handleEndKeyDown = (e) => {
        if (e.key === 'Backspace' && !getEndValue() && startInputRef.current) {
            startInputRef.current.focus();
        }
    };

    const isStartComplete = getStartValue().length === 8;

    return (
        <div className="internalCardContainer" style={{ textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "space-between", margin: "0" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <NumberFormat
                    getInputRef={startInputRef}
                    customInput={TextField}
                    format="##/##/####"
                    placeholder="DD/MM/YYYY"
                    mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                    type="text"
                    label={t("Data Inicial")}
                    InputLabelProps={{ shrink: true }}
                    value={getStartValue()}
                    onValueChange={handleStartChange}
                    onKeyDown={handleStartKeyDown}
                    InputProps={{
                        readOnly: readOnly,
                        style: { textAlign: 'center' }
                    }}
                    inputProps={{ 
                        style: { textAlign: 'center' },
                        readOnly: readOnly
                    }}
                    style={{ width: "auto", flex: 1 }}
                    readOnly={readOnly}
                    error={error}
                />

                <span style={{ margin: "15px 8px 0 8px", color: "rgba(0,0,0,0.54)", fontWeight: "bold" }}>-</span>

                <NumberFormat
                    getInputRef={endInputRef}
                    customInput={TextField}
                    format="##/##/####"
                    placeholder="DD/MM/YYYY"
                    mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                    type="text"
                    label={t("Data Final")}
                    InputLabelProps={{ shrink: true }}
                    value={getEndValue()}
                    onValueChange={handleEndChange}
                    onKeyDown={handleEndKeyDown}
                    disabled={!isStartComplete}
                    InputProps={{
                        readOnly: readOnly,
                        style: { textAlign: 'center' }
                    }}
                    inputProps={{
                        style: {
                            textAlign: 'center',
                            color: isStartComplete ? "currentColor" : "rgba(0,0,0,0.3)"
                        },
                        readOnly: readOnly
                    }}
                    style={{ width: "auto", flex: 1 }}
                    readOnly={readOnly}
                    error={error}
                />
            </div>
        </div>
    );
}

export default CoafDateRangePicker